import * as MSAL from "@azure/msal-angular";
import { MsalGuard, MsalRedirectComponent } from "@azure/msal-angular";
import {
  MSALGuardConfigFactory,
  MSALInstanceFactory,
  MSALInterceptorConfigFactory
} from "@core/util/msal-helper";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { LoginService } from "@core/services";
import { MsalLoginService } from "@core/services/login/msal-login.service";
import { TrustedRedirect } from "@core/services/trusted-redirect/trusted-redirect.service";

export const environment = {
  redirectMappings: {
    "medical-share-int": {
      redirectUrl:
        "https://i01.medicalshare.health.swisscom.ch/ms/client-portal/force-refresh-access-token-and-reload-app",
      displayName: "Medical Share (INT)"
    },
    "medical-share-prod": {
      redirectUrl:
        "https://medicalshare.health.swisscom.ch/ms/client-portal/force-refresh-access-token-and-reload-app",
      displayName: "Medical Share"
    }
  } as Record<string, TrustedRedirect>,
  authGuards: [MsalGuard],
  imports: [],
  providers: [
    {
      provide: LoginService,
      useClass: MsalLoginService
    },
    {
      provide: MSAL.MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL.MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL.MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MSAL.MsalInterceptor,
      multi: true
    },
    MSAL.MsalService,
    MSAL.MsalGuard,
    MSAL.MsalBroadcastService
  ],
  bootstrap: [MsalRedirectComponent],
  production: true,
  b2c: {
    policyNames: {
      signUpSignIn: "B2C_1A_HealthPortal",
      resetPassword: "B2C_1A_Reset_Password",
      editProfile: "B2C_1A_Edit_Profile",
      manageTotp: "B2C_1A_Manage_Totp",
      manageWebAuthn: "B2C_1A_Manage_Webauthn"
    },
    clientId: "0fc60cf5-3c56-4116-9384-164ecf72c787",
    tenantId: "dc5f3d15-71a0-47ad-a792-f708c9b4d123",
    authorityDomain: "tst-b2c.health.swisscom.ch"
  },
  api: {
    uri: "https://tst.api.health.swisscom.ch/portal",
    scopes: [`https://tst-b2c.health.swisscom.ch/HealthPortalFunctions/HealthPortal.ReadWrite.OwnedBy`]
  }
};
